import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AutoUpdate } from './lib/auto-update';
import './styles.css';
import './theme-2026.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter><AutoUpdate /><App /></BrowserRouter>
  </StrictMode>,
);
